export const API_KEY = "kEoyTwR9IxXPDZTDxarz8MX32YREZSSiEhLOrXW0mTYgAzFuj6R9ig==";
export const API_KEY_2 = "6N-P3bXbAk2tIj1_MUIEQeGQ6DjVIrS3xhBfniASVGp0AzFuVK1kNg==";
